module.exports = __webpack_public_path__ + "img/DateTime.15519baa.svg";